"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import LogoSettings from "./LogoSettings.jsx";
import AccountSettings from "./AccountSettings.jsx";
import OrganizationProductsBar from "../common/OrganizationProductsBar";

import { loadSettingsById, loadSsoSettingsById, getOrganizationById } from "../../actions/OrganizationActions";
import { saveSettings } from "../../actions/SettingsActions";
import Settings from "newApp/entities/Settings";
import validation from "../../utilities/SettingsValidation";

export class SettingsContainer extends Component {
    constructor (props) {
        super(props);
        this.state = {
            overlayMessage: ""
        };

        this.cancelClick = this.cancelClick.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
    }

    componentDidMount () {
        import("./_styles.scss");
        this.props.getOrganizationById(this.props.organizationId);
        this.props.getOrganizationSettings(this.props.organizationId);
        this.props.getSsoOrganizationSettings(this.props.organizationId);
    }

    getSaveButton (validationObject) {
        if (this.props.ssoSettings.hideSkipLink)
            return null;

        return (<button className="btn btn-primary btn-md push-button"
            disabled={!validationObject.isValid ? "disabled" : ""}
            id="btnSave"
            onClick={this.saveSettings}
            style={{ margin: "inherit" }}
            tabIndex="-1">Save
        </button>);
    }

    getCancelButton () {
        if (this.props.ssoSettings.hideSkipLink)
            return null;

        return (<button className="btn btn-default btn-md push-button"
            id="btnCancel"
            onClick={this.cancelClick}
            style={{ margin: "inherit" }}
            tabIndex="-1">Cancel
        </button>);
    }

    render () {
        if (this.props.redirectTo && this.props.redirectTo != "")
            window.location = this.props.redirectTo;

        if (this.props.settings == null || this.props.ssoSettings ==null)
            return null;

        const validationObject = validation.createValidationObject(this.props.settings);
        const hideSkipLink = this.props.ssoSettings.hideSkipLink;
        return (
            <div id="SettingsContainer">
                <div className="row">
                    <OrganizationProductsBar products={this.props.products}/>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <h2>Site Preferences</h2>
                    </div>
                </div>
                <div className="box col-md-12 settings-box">
                    <div className="col-md-12">
                        <div className="logo-settings-header">
                            <h4>Site Logo</h4>
                        </div>
                        <div className="account-settings-button-group">
                            {this.getCancelButton()}
                            {this.getSaveButton(validationObject)}
                        </div>
                    </div>

                    <LogoSettings organizationId={this.props.organizationId}/>

                    {!hideSkipLink && <AccountSettings settings={this.props.settings}
                        validationObject={validationObject}
                    />}
                </div>
            </div>
        );
    }

    //
    // UI handlers
    //
    cancelClick (e) {
        this.props.getOrganizationSettings(this.props.organizationId);
    }

    saveSettings () {
        this.setState({ overlayMessage: "Saving preferences..." });

        this.props.saveSettings(this.props.settings)
            .finally(() => {
                this.setState({ overlayMessage: "" });
            });
    }
}

SettingsContainer.defaultProps = {
    getOrganizationById: () => {},
    getOrganizationSettings: () => {},
    getSsoOrganizationSettings: () => {},
};

SettingsContainer.propTypes = {
    settings: PropTypes.instanceOf(Settings),
    getOrganizationSettings: PropTypes.func,
    getSsoOrganizationSettings: PropTypes.func,
    saveSettings: PropTypes.func
};

const mapStateToProps = state => ({
    redirectTo: state.appState.redirectTo,
    products: state.settingsState.products,
    settings: state.settingsState.settings,
    ssoSettings: state.settingsState.ssoSettings
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getOrganizationById: (organizationId) => dispatch(getOrganizationById(organizationId)),
        getOrganizationSettings: (organizationId) => dispatch(loadSettingsById(organizationId)),
        getSsoOrganizationSettings: (organizationId) => dispatch(loadSsoSettingsById(organizationId)),
        saveSettings: (settings) => dispatch(saveSettings(settings)),
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);
